import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Single KPI / stat card. Accent values are reserved for the figures that
 * should pull the eye; everything else stays body colour.
 */
export default function EntStatCard({
  label,
  value,
  hint,
  valueClassName = '',
  accent = false,
  to,
}) {
  const card = (
    <div className="ent-card">
      <div className="ent-card-label">{label}</div>
      <div className={`ent-card-value ${accent ? 'ent-accent' : ''} ${valueClassName}`.trim()}>
        {value}
      </div>
      {hint ? <div className="ent-card-sub">{hint}</div> : null}
    </div>
  );

  if (!to) return card;
  return (
    <Link to={to} className="ent-card-link">
      {card}
    </Link>
  );
}
